<script setup>
import { ref, onMounted } from 'vue';
import { setCookie, getCookie } from '../utils/cookies.js';

const showConsent = ref(false);

// Check if user has already accepted cookies
onMounted(() => {
  const cookieConsent = getCookie('cookie-consent');
  if (!cookieConsent) {
    // Show popup after a short delay for better user experience
    setTimeout(() => {
      showConsent.value = true;
    }, 1000);
  }
});

// Function to acknowledge cookies
function acknowledgeCookies() {
  setCookie('cookie-consent', 'accepted', 365); // Consent valid for 1 year
  showConsent.value = false;
}
</script>

<template>
  <div class="bottom-right-cookie-container" v-if="showConsent">
    <v-card class="update-card" :elevation="10">
      <div class="update-header">
        <div class="update-icon">
          <v-icon icon="mdi-cookie" color="white" size="large"></v-icon>
        </div>
        <div class="update-title-section">
          <div class="update-title">Cookie notice</div>
          <div class="update-version">Essential cookies</div>
        </div>
      </div>
      
      <div class="update-content">
        <p>This site uses essential cookies for proper functioning and improved performance.</p>
        
        <div class="update-features">          <div class="feature-item">
            <v-icon icon="mdi-check-circle" size="x-small" style="color: rgba(136, 0, 255, 1)" class="feature-icon"></v-icon>
            <span>Performance improvements</span>
          </div>
          <div class="feature-item">
            <v-icon icon="mdi-check-circle" size="x-small" style="color: rgba(136, 0, 255, 1)" class="feature-icon"></v-icon>
            <span>Essential functionality</span>
          </div>
        </div>
      </div>
        <div class="update-actions">
        <v-btn
          @click="acknowledgeCookies"
          class="accept-btn"
        >
          <v-icon icon="mdi-check-circle-outline" size="small" class="mr-1"></v-icon>
          I Understand
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<style scoped>
.bottom-right-cookie-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  width: 320px;
  animation: fadeIn 0.4s ease-out;
}

.update-card {
  border-radius: 8px !important;
  width: 100%;
  overflow: hidden;
  background-color: #1a1a2e !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
}

.update-header {
  display: flex;
  align-items: center;
  padding: 16px;
}

.update-icon {
  background: var(--tertiary-color);
  border-radius: 12px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  box-shadow: 0 4px 8px rgba(136, 0, 255, 0.4);
}

.update-title-section {
  display: flex;
  flex-direction: column;
}

.update-title {
  font-weight: 600;
  letter-spacing: 0.5px;
  color: white;
  font-size: 1rem;
}



.update-version {
  font-size: 0.75rem;
  padding: 2px 8px;
  background-color: rgba(136, 0, 255, 0.2);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.85);
  display: inline-block;
  margin-top: 4px;
  width: fit-content;
}

.update-content {
  padding: 0 16px 12px;
}

.update-features {
  background-color: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  margin-top: 12px;
  padding: 12px;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.feature-item:last-child {
  margin-bottom: 0;
}

.feature-icon {
  margin-right: 8px;
  background-color: rgba(136, 0, 255, 0.1);
  padding: 3px;
  border-radius: 50%;
}

.update-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 16px;
  background-color: rgba(0, 0, 0, 0.2);
}

.accept-btn {
  background: var(--tertiary-color) !important;
  color: white !important;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
  font-size: 0.8rem !important;
  padding: 0 16px !important;
}

.accept-btn:hover {
  box-shadow: 0 4px 12px rgba(136, 0, 255, 0.4) !important;
  transform: translateY(-1px);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

p {
  font-size: 0.85rem;
  line-height: 1.5;
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
}

span {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.85);
}
</style>
